import { PropertyListServiceType } from "../../domain/services/property-list-service";
import fetch from "isomorphic-unfetch";
import PropertyList from "../../domain/models/property-list";

export class PropertyListService implements PropertyListServiceType {
  async getPropertyLists(): Promise<PropertyList[]> {
    const res = await fetch(
      `${process.env.NEXT_PUBLIC_API_URL}/property-lists?_sort=title:ASC`
    );
    const resData = await res.json();
    if (res.ok) {
      const propertyLists = resData.map((o) => new PropertyList().fromJson(o));
      return propertyLists;
    }
    throw new Error(resData.message);
  }
}
